<template>
  <page-header-wrapper>
    <div slot="extra">
      <a-button
        type="primary"
        icon="plus"
        v-action:update
        @click="append('新建一级组织', 0)"
      >
        新建一级组织
      </a-button>
    </div>

    <a-card :bordered="false">
      <a-tree default-expand-all :treeData="treeData">
        <template slot="custom" slot-scope="item">
          <span>{{ item.title }}</span>
          <template>
            <span class="d-flex actions">
              <a-button
                type="link"
                size="small"
                v-action:update
                @click="append(item.title + '子级', item.id)"
              >
                添加子级
              </a-button>
              <a-button
                type="link"
                size="small"
                v-action:update
                @click="edit('编辑' + item.title, item.id)"
              >
                编辑
              </a-button>
              <a-popconfirm
                title="确定要删除该条章节吗？"
                ok-text="确定"
                cancel-text="取消"
                @confirm="handleTreeDelete(item.id)"
                v-action:delete
                v-if="!(item.children && item.children.length)"
              >
                <a-button type="link" size="small">删除</a-button>
              </a-popconfirm>
            </span>
          </template>
        </template>
      </a-tree>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { Tree } from 'ant-design-vue'
import { tree, list, category } from '@/mixins' // 引入
import { TableToolBarList, StandardFormRow } from '@/components'
import ModelForm from './modules/ModelForm'

const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        sorter: true
    },
    {
        title: '标题',
        dataIndex: 'title',
        scopedSlots: { customRender: 'name' }
    },
    {
        title: '排序',
        dataIndex: 'order',
        sorter: true
    },
    {
        title: '创建时间',
        sorter: true,
        dataIndex: 'created_at'
    },
    {
        title: '状态',
        sorter: true,
        dataIndex: 'state',
        scopedSlots: { customRender: 'state' }
    },
    {
        title: '操作',
        dataIndex: 'operation',
        width: 140,
        scopedSlots: { customRender: 'operation' }
    }
]
const apiList = {
    getList: '/settings/organization',
    delete: '/settings/organization/',
    changeState: '/settings/organization/'
}
export default {
    name: 'OrganizationList',
    mixins: [tree, list, category], // 使用mixins
    components: {
        ATree: Tree,
        TableToolBarList,
        StandardFormRow,
        ModelForm
    },
    data () {
        return {
            replaceFields: {
                key: 'id'
            },
            apiList,
            params: {
                where: {},
                perpage: 100,
                type: 1
            },
            columns, // 表头
            settingColumns: JSON.parse(JSON.stringify(columns)) // 深度复制表头
        }
    },
    mounted () {
        this.getTreeLists() // 获取分类列表
    },
    methods: {
        /**
         * @Author: JDY
         * @Date: 2021-04-27 16:24:14
         * @LastEditTime: Do not edit
         * @LastEditors: JDY
         * @Description: 添加
         * @param  {*}
         * @return {*}
         * @param {*} title
         * @param {*} data
         */
        append (title, data) {
            // 添加
            const that = this
            that.$dialog(
                ModelForm,
                {
                    pid: data,
                    on: {
                        ok () {
                            // that.getTreeLists()
                        }
                    }
                },
                {
                    title: title,
                    centered: true,
                    width: 700,
                    okText: '提交',
                    cancelText: '关闭',
                    maskClosable: false
                }
            )
        },
        /**
         * @Author: JDY
         * @Date: 2021-04-27 16:24:04
         * @LastEditTime: Do not edit
         * @LastEditors: JDY
         * @Description:编辑
         * @param  {*}
         * @return {*}
         * @param {*} title
         * @param {*} aid
         */
        edit (title, id) {
            const that = this
            that.$dialog(
                ModelForm,
                {
                    id,
                    on: {
                        ok () {
                            that.getTreeLists()
                        }
                    }
                },
                {
                    title: title,
                    centered: true,
                    width: 700,
                    okText: '提交',
                    cancelText: '关闭',
                    maskClosable: false
                }
            )
        }
    }
}
</script>

<style lang="less" scoped>
/deep/.ant-tree-title {
    width: 100%;
    display: flex;
    &:hover {
        .actions {
            display: block;
        }
    }
}
/deep/.ant-tree li .ant-tree-node-content-wrapper {
    width: calc(100% - 24px);
}

.ant-card-body {
    :global {
        .ant-tree {
            line-height: 3;
            li {
                position: relative;
            }
        }
    }
}
.actions {
    display: none;
}
</style>
